// extracted by mini-css-extract-plugin
export default {"DialogContent":"RemoveDeviceDialog_DialogContent__1nc8m","ErrorMessage":"RemoveDeviceDialog_ErrorMessage__Sa1p6"};